<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-alert />
        <p v-if="rm.completedDate && rm.completedDate.length > 0">The mitigation tasks below were created as part of the most recent risk management plan completed on {{rm.completedDate|formatDate('YYYY-MM-DD')}}.</p>
        <p v-else>Once you have completed a <b-button variant="link" class="px-0" to="/risk/start">risk management plan</b-button>, the mitigation tasks will show up below.</p>
        <hm-spinner v-if="!ready" />
      </b-col>
    </b-row>

    <b-row class="pt-4" v-show="ready">
      <b-col>
        <h4>Open Mitigation Tasks</h4>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-show="ready">
      <b-col>
        <b-table class="p-1" responsive bordered hover show-empty empty-text="No Open Mitigation Tasks" :items="openTasks" :fields="openColumns" @row-clicked="rowClick">
          <template slot="cell(dueDate)" slot-scope="data">{{data.value|formatDate('YYYY-MM-DD')}}</template>
        </b-table>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-show="ready">
      <b-col>
        <h4>Closed Mitigation Tasks</h4>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-show="ready">
      <b-col>
        <b-table class="p-1" responsive bordered hover show-empty empty-text="No Closed Mitigation Tasks" :items="completedTasks" :fields="completedColumns" @row-clicked="rowClick">
          <template slot="cell(status)" slot-scope="data">{{riskMap.TaskStatus[data.value]}}</template>
          <template slot="cell(completedDate)" slot-scope="data">{{data.value|formatDate('YYYY-MM-DD')}}</template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { riskService } from '@/services'
import Enumerable from 'linq/linq.js'

export default {
  name: 'TaskList',
  data() {
    return {
      rm: {
        completedDate: '',
        tasks: []
      },
      openColumns: [{
        key: 'title',
        label: 'Safeguard',
        sortable: true
      }, {
        key: 'dueDate',
        label: 'Due On',
        sortable: true
      }],
      completedColumns: [{
        key: 'title',
        label: 'Safeguard',
        sortable: true
      }, {
        key: 'completedDate',
        label: 'Closed On',
        sortable: true
      }, {
        key: 'status',
        label: 'Status'
      }],
      ready: false
    }
  },
  computed: {
    ...mapState('maps', ['riskMap', 'safeguardsMap']),
    openTasks() {
      return Enumerable.from(this.rm.tasks)
        .where(x => { return x.value.status == 'open' })
        .join(JSON.parse(JSON.stringify(this.safeguardsMap)),
          function (o) { return o.key; },
          function (i) { return i.id; },
          function (o, i) { return { id: i.id, title: i.title, status: o.value.status, dueDate: o.value.dueDate }; })
        .orderBy(x => { return x.dueDate; })
        .toArray();
    },
    completedTasks() {
      return Enumerable.from(this.rm.tasks)
        .where(x => { return x.value.status != 'open' })
        .join(JSON.parse(JSON.stringify(this.safeguardsMap)),
          function (o) { return o.key; },
          function (i) { return i.id; },
          function (o, i) { return { id: i.id, title: i.title, status: o.value.status, dueDate: o.value.dueDate, completedDate: o.value.completedDate }; })
        .orderBy(x => { return x.dueDate; })
        .toArray();
    }
  },
  methods: {
    ...mapActions({
      alertException: 'alert/exception'
    }),
    rowClick(record, index) {
      this.$router.push({ name: 'TaskEdit', params: { id: record.id } });
    }
  },
  created() {
    this.ready = false;

    Promise.all([
      this.$store.dispatch('maps/fetchRiskMap'),
      this.$store.dispatch('maps/fetchSafeguardsMap'),
      riskService.getActiveRiskManagement()
    ]).then((values) => {
      this.rm = values[2];
    }).catch((err) => {
      if (err.status === 404) {
        // ignore the not found case
        console.log('No active risk management plan found!');
      } else {
        this.alertException({ err, message: 'Error loading data.' });
      }
    }).finally(() => {
      this.ready = true;
    })
  }
}
</script>
